var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-button"},[_c('font-awesome-icon',{staticClass:"add-icon",attrs:{"icon":['fal', 'plus-circle']}}),_c('span',[_vm._v(_vm._s(_vm.$t('knowledge.action-triggers.action')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }